import React from 'react';
import { styled } from 'linaria/react';
import AddToCart from '../../Cart/AddToCart';
import { ButtonUI } from '../../ui/ButtonUI';
import ProductLink from '@jetshop/ui/ProductLink';
import Image from '@jetshop/ui/Image';
import { transparentDataImg } from '@jetshop/ui/Image/Image';
import Badges from '@jetshop/ui/ProductList/Badges';
import t from '@jetshop/intl';
import { theme } from '../../Theming/Theming';
import { GridPrice } from '../../Price';

const ProductWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid ${theme.colors.border};
  &:last-child {
    border-bottom: 1px solid ${theme.colors.border};
  }
  ${theme.above.lg} {
    &:nth-last-child(2) {
      border-bottom: 1px solid ${theme.colors.border};
    }
  }
  padding: 0.8rem 0;
  .related-product-image {
    width: 30%;
    ${theme.only.md} {
      width: 15%;
    }
    ${theme.above.lg} {
      width: 15%;
    }
    .badge-wrapper {
      img {
        width: 40px;
        height: 40px;
      }
    }
  }
  .related-product-detail {
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    ${theme.only.md} {
      width: 85%;
    }
    ${theme.above.lg} {
      width: 85%;
    }
    .related-product-header {
      width: 100%;
      padding: 0 1rem;
      ${theme.only.md} {
        width: 70%;
      }
      ${theme.above.xl} {
        width: 70%;
      }
      > div {
        margin-top: 0.5rem;
      }
    }
    .related-product-cta {
      width: 100%;
      margin-top: 1rem;
      ${theme.only.md} {
        width: 30%;
      }
      ${theme.above.xl} {
        width: 30%;
      }
      button {
        width: 100%;
        border-radius: 50px;
      }
    }
  }
`;

export const RelatedProduct = ({ product, quickBuy }) => {
  //HAS IMAGES
  const hasImages = product.images && product.images.length > 0;

  //STANDARD PRODUCT IMAGE
  let images = product && product.images;
  return (
    <ProductWrapper product={product} categoryPath={null}>
      <div className="related-product-image">
        <ProductLink product={product}>
          {hasImages ? (
            <Image
              sizes={[200]}
              aspect={'1:1'}
              alt={images[0].alt}
              src={images[0].url}
            >
              <div className="badge-wrapper">
                <Badges badges={product.badges} />
              </div>
            </Image>
          ) : (
            <Image src={transparentDataImg} />
          )}
        </ProductLink>
      </div>
      <div className="related-product-detail">
        <header className="related-product-header">
          <ProductLink product={product}>
            <h4>{product.name}</h4>
          </ProductLink>
          <p className="sub-name">{product.subName}</p>
          <p
            className="short-description"
            dangerouslySetInnerHTML={{ __html: product.shortDescription }}
          />
          <GridPrice
            price={product.price}
            previousPrice={product.previousPrice}
          />
        </header>
        <div className="related-product-cta">
          {quickBuy &&
          !product.hasVariants &&
          product.stockStatus &&
          product.stockStatus.buyable ? (
            <AddToCart
              product={product}
              quantity={1}
              selectedVariation={product}
            >
              {(add) => (
                <ButtonUI
                  css={{ marginTop: '1rem' }}
                  className="buy list"
                  onClick={() => {
                    add();
                  }}
                >
                  {t('Add to')}
                </ButtonUI>
              )}
            </AddToCart>
          ) : (
            <ProductLink product={product}>
              <ButtonUI className="list">{t('Go to')}</ButtonUI>
            </ProductLink>
          )}
        </div>
      </div>
    </ProductWrapper>
  );
};
